import React from 'react';

function Clients() {
	return (
		<section id="clients">
			<h2>Clients/Experience</h2>
			<p>Over the last several years I've been fortunate enough to work on a wide variety of websites, from a single landing page for a new businesses to testing changes for multinational organisations. Below is a brief selection of websites I've spent a reasonable/significant amount of time working on.</p>
			<ul>
				<li>
					<h3><a href="https://www.ambrosewilson.com/">Ambrose Wilson</a></h3>
					<p className="note">Ambrose Wilson is an N Brown brand specialising in clothing for 65+ women. Other N Brown brands include Jacamo, Simply Be and JD Williams.</p>
					<p className="note">During my time at N Brown I have been solely responsible for the testing and optimisation program for the Ambrose Wilson website. This has included planning out the testing roadmap, designing and developing A/B tests & personalisation experiences, monitoring and analysing test data and reporting results to relevant stakeholders.</p>
					<p className="note">CRO Strategy, A/B & MVT Testing, Personalisation, Marketing Campaign Messaging, Report Automation, User Journey Mapping</p>
					<p className="note">Monetate, Teradata</p>
				</li>
				<li>
					<h3><a href="https://www.jurysinns.com/">Jurys Inn</a></h3>
					<span className="note">Hotel chain specialising in city-centre locations across the UK (and a location in prague)</span>
					<p className="note">A/B & MVT Testing, Personalisation, Site Speed Optimisation, Exit Intent Messaging</p>
					<p className="note">Google Optimize 360, VWO, Sentient Ascend</p>
				</li>
				<li>
					<h3><a href="https://musicmagpie.co.uk/">Music Magpie</a> & <a href="https://www.decluttr.com/">Decluttr</a></h3>
					<span className="note">A recommerce business with brands in the US and UK. They both buy and sell a wide range of Tech, CD's, DVD's &amp; even Lego!</span>
					<p className="note">A/B Testing, Social Proof Messaging, Exit Intent Messaging</p>
					<p className="note">Google Optimize 360, VWO</p>
				</li>
				<li>
					<h3><a href="https://www.motoring.co.uk/">Motoring.co.uk</a> & MyMotoring</h3>
					<span className="note">Motoring.co.uk is a website specialising in car news, reviews, valuations and comparisons. MyMotoring was a sister site that allows users to interact with one another and keep track of important information relating to their vehicle (such as MOT &amp; tax dates).</span>
					<p className="note">Front End Development</p>
					<p className="note">HTML, CSS, JavaScript, PHP</p>
				</li>
				<li>
					<h3><a href="https://www.aspinaloflondon.com/">Aspinal of London</a></h3>
					<span className="note">Aspinal of London is a London designer, manufacturer and retailer of luxury leather goods and accessories for men and women. Held in high regard by many celebrities and social influencers, their clientele includes models, actors and members of the royal family.</span>
					<p className="note">A/B Testing, Personalisation, Site Speed Optimisation, Exit Intent Messaging</p>
					<p className="note">Google Optimize 360, VWO, Qubit</p>
				</li>
				<li>
					<h3><a href="https://m.barratthomes.co.uk">Barratt Homes</a>, <a href="https://m.barratthomes.co.uk">Barratt London</a>, <a href="https://m.dwh.co.uk/">DWH</a></h3>
					<span className="note">Brands owned by Barratt Developments plc, one of the largest residential property development companies in the United Kingdom operating a network of over 30 divisions.</span>
					<p className="note">A/B Testing, Feature Implementation Testing</p>
					<p className="note">VWO</p>
				</li>
			</ul>
		</section>
	);
}

export default Clients;
